import { router } from 'expo-router';
import { StyleSheet, Text, View } from 'react-native';

import { useAuth } from '@/src/features/auth/use-auth';
import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

import { BrandLogo } from './BrandLogo';
import { Button } from './Button';

export function SessionRecoveryView() {
  const { retryAuthInitialization } = useAuth();

  return (
    <View style={styles.container}>
      <BrandLogo centered size="md" variant="icon" />
      <View style={styles.copy}>
        <Text style={styles.title}>Session check is taking too long</Text>
        <Text style={styles.message}>
          Your connection may be slow, or the browser may be having trouble
          restoring your saved session.
        </Text>
      </View>
      <View style={styles.actions}>
        <Button title="Try again" onPress={retryAuthInitialization} />
        <Button
          title="Sign in"
          variant="secondary"
          onPress={() => {
            router.replace('/sign-in');
          }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  actions: {
    alignSelf: 'stretch',
    gap: spacing.md,
  },
  container: {
    alignItems: 'center',
    backgroundColor: colors.background,
    flex: 1,
    gap: spacing.lg,
    justifyContent: 'center',
    padding: spacing.xl,
  },
  copy: {
    gap: spacing.sm,
  },
  message: {
    color: colors.mutedText,
    fontSize: 16,
    lineHeight: 22,
    textAlign: 'center',
  },
  title: {
    color: colors.text,
    fontSize: 22,
    fontWeight: '800',
    textAlign: 'center',
  },
});
